import { render, staticRenderFns } from "./UserActionsNavigation.vue?vue&type=template&id=b95ce1bc&scoped=true&"
import script from "./UserActionsNavigation.vue?vue&type=script&lang=js&"
export * from "./UserActionsNavigation.vue?vue&type=script&lang=js&"
import style0 from "./UserActionsNavigation.vue?vue&type=style&index=0&id=b95ce1bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b95ce1bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/var/www/nmg-charitychallenge.com/charity-challenge/frontbuild/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTabs } from 'vuetify/lib'
installComponents(component, {VTabs})
